<template>
  <div>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <router-link class="button is-primary" :to="{ name: 'private-apps-create' }">Create New</router-link>
        </p>
      </div>
    </nav>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Name</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="app in apps" :key="app.id">
          <td>
            <router-link :to="{ name: 'private-apps-edit', params: { id: app.id } }">{{ app.name }}</router-link>
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import { appsApi } from '@/features/apps/shared/services/apps';
import { PrivateApp } from '@/features/apps/shared/models';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);

const apps = ref<PrivateApp[]>([]);

const emit = defineEmits<{
  (e: 'loading'): void;
  (e: 'loaded'): void;
}>();

onBeforeMount(() => {
  emit('loading');
  if (!currentWorkspace.value) {
    handleSeriousError('No workspace selected');
    return;
  }

  appsApi
    .listPrivate(currentWorkspace.value.id)
    .then((loadedApp) => {
      apps.value = loadedApp;
    })
    .catch((err) => {
      handleSeriousError(err.message);
    })
    .finally(() => emit('loaded'));
});
</script>
